import LoginPage from './Login';
import './Login.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Actions
import {
  createNewUserOrSignIn,
  invalidateAllAuth
} from '../../redux/auth/actions';

import {
  setLoading
} from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {
    authToken: state.auth.authToken,
    userId: state.auth.userId,
    cardNumber: state.loyalty.cardNumber,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Auth
    createNewUserOrSignIn,
    invalidateAllAuth,

    // Loading
    setLoading,
  }, dispatch);
}

const ConnectedLoginPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LoginPage));

export default ConnectedLoginPage;



// WEBPACK FOOTER //
// ./src/pages/Login/index.js